<template>
    <div>
        <div class="col-6 col-sm-8 d-flex align-items-center">
            <ui-checkbox-input
                class="text-primary text-sm"
                :name="`shop-${sKey}`"
                :value="!!selectedShop"
                @change="onShopSelectToggle"
                :label="setShopLabel"
                :disabled="
                    price === 0 ||
                        price === null ||
                        price === '' ||
                        price === '0.00'
                "
            />
        </div>
        <div class="col-3 col-sm-2 richTable-prices">
            <div class="input-currency input-currency-sm">
                <money-input
                    :validation="moneyInputValidate"
                    :class="{ 'is-danger': isDanger }"
                    :placeholder="+(+shop.price_normal).toFixed(2)"
                    :price="+price"
                    :small="true"
                    @onChange="changePrice($event)"
                />
            </div>
        </div>
        <div class="col-3 col-sm-2 richTable-prices">
            <input
                class="form-control form-control-sm"
                min="1"
                type="number"
                v-model="copies"
                @change="selectLabel(true)"
                @keyup="changeCopies"
                @click="changeCopies"
                :placeholder="shop.print_copies"
            />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            copies: this.shop.print_copies ? this.shop.print_copies : 1,
            price: this.selectedShop
                ? this.selectedShop.price_normal
                : this.shop.price_normal
                    ? this.shop.price_normal
                    : 0,
            isDanger: false
        }
    },
    props: {
        moneyInputValidate: {
            type: Boolean,
            default: true
        },
        shop: {
            type: Object,
            required: true
        },
        sKey: {
            type: String,
            required: true
        },
        productId: {
            type: Number,
            required: true
        },
        promoId: {
            type: Number,
            required: true
        },
        downloadLabel: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onShopSelectToggle(selected) {
            if (selected) {
                this.selectedShop = this.shop
                return
            }
            this.selectedShop = false
        },
        selectLabel(value) {
            this.isDanger = false
            this.shop.price_normal = this.price
            this.shop.print_copies = this.copies
            if (value && !this.price) {
                this.isDanger = true
            }
        },
        changeCopies() {
            if (this.copies === '') {
                this.copies = 1
            }
            this.selectLabel(true)
        },
        changePrice(event) {
            this.price = (+event).toFixed(2)
            if (this.price) {
                this.selectLabel(true)
            } else {
                this.selectLabel(false)
            }
        }
    },
    computed: {
        selectedShop: {
            get() {
                return this.$store.getters.getSelectedLabelShop({
                    subId: this.shop.subscription_id,
                    productId: this.productId
                })
            },
            set(value) {
                this.selectLabel(value)
            }
        },
        promoType() {
            return this.$store.getters.getLabelTypeById(this.promoId)
        },
        setShopLabel() {
            const data = this.shop
            return `${data.name}, ${this.$store.getters.getShopAddress(data)}`
        }
    },
    created() {
        if (this.selectedShop) {
            this.price = this.selectedShop.price_normal
            this.copies = this.selectedShop.print_copies
        }
        if (this.shop.price_normal) {
            this.price = this.shop.price_normal
        }
    }
}
</script>
